import jQuery from 'jquery';
import Debug from 'debug';
import { hidePopovers } from './lobuilder.jquery.js';

const debug = Debug('gh:lobuilder:popup');

(function ($) {
  $(document).ready(function () {
    // Close popovers on click away
    $('body').on('click', function (e) {
      const target = e.target;
      const thisHasClass = $(target).hasClass('popover') || $(target).closest('.popover').length > 0;
      const isTrigger = $(target).hasClass('trigger-common') || $(target).closest('.trigger-common').length > 0;
      const isHotspot = $(target).closest('.hotspot, .xs-hotspot, .HotSpotDefault').length > 0;
      if (!thisHasClass && !isTrigger && !isHotspot) {
        debug('Hiding all popovers');
        hidePopovers();
      }
    });
  });
}(jQuery));



// WEBPACK FOOTER //
// Glasshouse/Core/js/popup.js